import { toast } from "../lib/toast";
import { stringToArray } from "./array";

export function capitalize(value: string) {
  let capitalizedText = "";
  const conjunctions = [
    "an",
    "a",
    "the",
    "of",
    "and",
    "but",
    "for",
    "nor",
    "or",
    "so",
    "yet",
    "in",
    "on",
    "at",
    "to",
    "by",
    "with",
  ];

  const textArray = value?.split(" ");

  for (let i = 0; i < textArray?.length; i++) {
    let word = textArray[i];
    if (i === 0 || word?.endsWith(".")) {
      capitalizedText +=
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase() + " ";
    } else if (conjunctions?.includes(word?.toLowerCase())) {
      capitalizedText += word?.toLowerCase() + " ";
    } else {
      capitalizedText +=
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase() + " ";
    }
  }

  return capitalizedText?.trim();
}

export function returnFirstChar(value: string) {
  return value?.charAt(0)?.toUpperCase();
}

export function removeQuotesFromText(input: string) {
  return input?.replace(/"/g, "");
}

export function sliceUrl(str: string = "", size: number, dot?: string) {
  const splitStr = str?.split(".");
  splitStr.pop();
  const newStr = splitStr?.join();

  return newStr?.length > size
    ? `${newStr?.slice(0, size)}${dot || ""}`
    : newStr;
}

export const getExtension = (url: string) => {
  const file = stringToArray(url, ".") as string[];
  return file?.[file?.length - 1]?.toLowerCase();
};

export function formatUrl(url?: string): string | undefined {
  if (!url) return undefined;

  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  return `https://${url}`;
}

export function parseJSON(val: string) {
  try {
    return JSON.parse(val);
  } catch (error) {
    toast("error", "JSON parse fail");
    return null;
  }
}

export function valueOrNa(val: any) {
  return val === null || val === undefined ? "n/a" : val;
}
